export const DELAY_CLOSE_ON_ADD = 1200;
